import PropTypes from "prop-types";

import { CheckSolidV6 } from "@shared/v2/Icomoon";

const Toast = ({ containerClassName, text, Icon, iconClassName, textClassName }) => <div className={`tw-fixed tw-left-1/2 tw-bg-[#EDFAF1] tw-border tw-border-solid tw-border-[#CAF0D6] tw-z-2 tw-flex tw-justify-center tw-items-center tw-gap-[8px] tw-px-12px tw-rounded-[8px] ${containerClassName}`}>
  <Icon size="l" className={iconClassName} />
  <span className={`tw-text-12d tw-text-[#177335] ${textClassName}`}>{text}</span>
</div>

export default Toast;

Toast.propTypes = {
  containerClassName: PropTypes.string,
  text: PropTypes.string.isRequired,
  Icon: PropTypes.func,
  iconClassName: PropTypes.string,
  textClassName: PropTypes.string,
};

Toast.defaultProps = {
  containerClassName: '',
  Icon: CheckSolidV6,
  iconClassName: 'tw-text-[#36B25F]',
  textClassName: '',
};